import ContactHero from '../../components/ContactHero';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import SupportSection from '../../components/SupportSection';

function ContactUs() {
  return (
    <>
      <Header />
      <main>
        <ContactHero />
        <SupportSection />
      </main>
      <Footer />
    </>
  );
}

export default ContactUs;
